import { render } from "./SimpleDate.vue?vue&type=template&id=16d8b1d0&scoped=true&ts=true"
import script from "./SimpleDate.vue?vue&type=script&lang=ts"
export * from "./SimpleDate.vue?vue&type=script&lang=ts"

import "./SimpleDate.vue?vue&type=style&index=0&id=16d8b1d0&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16d8b1d0"]])

export default __exports__